import React from "react";
import classNames from "classnames";
import useWithStore from "@/Hooks/useWithStore";
import Link from "@/Layouts/Link";
import "@/Scss/nav.scss";

const Nav = (props) => {
    const {stores = {}, soulSubMenu = []} = props;
    const {subMenuStore = {}} = stores;

    // const subMenuClasses = classNames('nav__item', props.className, {
    //     'open': subMenuStore.subMenuFlag
    // });

    const subMenuContainerClasses = classNames('sub-menu', props.className, {
        'open': subMenuStore.subMenuFlag
    });

    const subMenuOverlayClasses = classNames('soul-sub-menu-overlay', props.className, {
        'open': subMenuStore.subMenuFlag
    });

    return (
        <nav className={`nav`}>
            <div className={`container`}>
                <Link className={`nav__item`} href={`/stocks`}>Акции</Link>
                {/*<Link className={`nav__item`} href={`/wheel-of-fortune`}>Розыгрыш</Link>*/}
                {/*<Link className={`nav__item`} href={`/buket-podarkov`}>Розыгрыш</Link>*/}
                {/*<Link className={`nav__item`} href={`/secret-santa`}>Тайный Санта</Link>*/}
                <Link className={`nav__item`} href={`/diamonds`}>Diamonds</Link>
                {/*<Link className={`nav__item`} href={`/advent-calendar`}>Календарь подарков</Link>*/}
                {/*<p className={subMenuClasses} onClick={() => subMenuStore.subMenuOpen()}>*/}
                {/*    Соул-браслеты*/}
                {/*</p>*/}
                <Link className={`nav__item`} href={`/wedding`}>Свадьба</Link>
                <Link className={`nav__item`} href={`/collections`}>Коллекции</Link>
                <Link className={`nav__item`} href={`/gift-certificate`}>Подарочные сертификаты</Link>
                <Link className={`nav__item`} href={`/b2b`}>Бизнесу</Link>
                <Link className={`nav__item`} href={`/about-company`}>О компании</Link>
                <Link className={`nav__item`} href={`/blog`}>Блог</Link>
                <Link className={`nav__item`} href={`/contacts`}>Контакты</Link>
            </div>
            {subMenuStore.subMenuFlag && (
                <>
                    <div className={subMenuContainerClasses}>
                        <div className={`container`}>
                            <div className={`sub-menu__wrapper`}>
                                {soulSubMenu.map((el) => {
                                    return <Link key={el.id} className={`sub-menu__item`} href={`${el.link}`}>
                                        {el.name}
                                    </Link>
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={subMenuOverlayClasses} onClick={() => subMenuStore.closeSubMenu()}></div>
                </>
            )}
        </nav>
    );
}

export default useWithStore(Nav);
